module.exports={currentEnv:"stage",username:"thenightbeforeproductions",password:"fiafia2021",forceLoginEnv:["stage","prod"]};